export const decryptDetails = async (cipherText, key) => {
  try {
    // Helper function to decode URL-safe Base64
    const decodeBase64 = (data) => {
      const paddedData = data.padEnd(data.length + (4 - (data.length % 4)) % 4, "="); // Add padding if needed
      return atob(paddedData.replace(/-/g, "+").replace(/_/g, "/")); // Replace URL-safe Base64 and decode
    };

    // Decode the Base64 cipherText
    const decodedData = decodeBase64(cipherText);

    // Ensure the key length matches the decoded data length
    key = key.repeat(decodedData.length);

    // Perform XOR decryption
    let decrypted = "";
    for (let i = 0; i < decodedData.length; i++) {
      decrypted += String.fromCharCode(
        decodedData.charCodeAt(i) ^ key.charCodeAt(i)
      );
    }

    // Parse the decrypted string as JSON
    let decryptedData;
    try {
      decryptedData = JSON.parse(decrypted);
      console.log("Decrypted data:", decryptedData);
    } catch (error) {
      console.error("Error parsing decrypted data:", error.message);
      throw new Error("Failed to parse decrypted data. Invalid format.");
    }

    // Extract required fields: patient_id (patient ID), room_id (room ID), and doctor_name
    const { patient_id, room_id, doctor_name } = decryptedData;
    if (!patient_id || !room_id || !doctor_name) {
      throw new Error("Missing required fields in decrypted data.");
    }

    // Return the decrypted data with the required fields
    return { patient_id, room_id, doctor_name };
  } catch (error) {
    console.error("Decryption error:", error.message);
    throw new Error("Decryption failed. Please check the encrypted data or key.");
  }
};
